import type { Cart } from "@packages/sdk";

type GetTrialEndDateProps = { cart?: Cart };

export const getTrialEndDate = ({ cart }: GetTrialEndDateProps) => {
  if (cart)
    return new Date(cart?.trial_end_date || new Date()).toLocaleDateString();

  return null;
};
